import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { CheckCircle, Package, Download, ArrowRight } from 'lucide-react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import PageSEO from '../components/SEO/PageSEO';

const OrderConfirmationPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // Schéma JSON-LD pour la page de confirmation
  const schema = {
    "@context": "https://schema.org",
    "@type": "CheckoutPage",
    "name": "Confirmation de commande - Comprendre les SES",
    "description": "Votre commande a été confirmée et sera bientôt expédiée.",
    "breadcrumb": {
      "@type": "BreadcrumbList",
      "itemListElement": [
        {
          "@type": "ListItem",
          "position": 1,
          "name": "Accueil",
          "item": "https://cours-ses.fr"
        },
        {
          "@type": "ListItem",
          "position": 2,
          "name": "Panier",
          "item": "https://cours-ses.fr/cart"
        },
        {
          "@type": "ListItem",
          "position": 3,
          "name": "Confirmation",
          "item": "https://cours-ses.fr/confirmation"
        }
      ]
    }
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <PageSEO
        title="Commande confirmée - Comprendre les SES"
        description="Votre commande a été confirmée et sera bientôt expédiée. Merci pour votre achat !"
        path="/confirmation"
        image="https://cours-ses.fr/Logo SES.png"
        schema={schema}
      />
      <Navbar />
      <main className="pt-16">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
          <div className="bg-white rounded-xl shadow-lg p-8">
            {/* En-tête */}
            <div className="text-center mb-8">
              <div className="flex justify-center mb-6">
                <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center">
                  <CheckCircle className="w-10 h-10 text-green-500" />
                </div>
              </div>
              <h1 className="text-2xl font-bold text-[#323c5f] mb-2">
                Merci pour votre commande !
              </h1>
              <p className="text-gray-600">
                Votre commande a été confirmée et sera bientôt expédiée.
              </p>
            </div>

            {/* Détails de la commande */}
            <div className="bg-[#9a6ebd]/5 rounded-lg p-6 mb-8">
              <h2 className="font-semibold text-[#323c5f] mb-4 flex items-center">
                <Package className="mr-2" size={20} />
                Détails de la livraison
              </h2>
              <div className="space-y-3 text-gray-600">
                <p>
                  Votre commande sera expédiée sous 2-3 jours ouvrés via Colissimo.
                </p>
                <p>
                  Vous recevrez un email avec le numéro de suivi dès que votre colis 
                  sera pris en charge par notre transporteur.
                </p>
              </div>
            </div>

            {/* Ressources gratuites */}
            <div className="bg-[#9a6ebd]/5 rounded-lg p-6 mb-8">
              <h2 className="font-semibold text-[#323c5f] mb-4 flex items-center">
                <Download className="mr-2" size={20} />
                En attendant votre colis...
              </h2>
              <p className="text-gray-600 mb-4">
                Découvrez nos ressources gratuites pour commencer à réviser dès maintenant !
              </p>
              <Link
                to="/ressources"
                className="inline-flex items-center text-[#9a6ebd] hover:text-[#8a5dad] transition-colors"
              >
                Accéder aux ressources
                <ArrowRight className="ml-1" size={16} />
              </Link>
            </div>

            {/* Boutons d'action */}
            <div className="space-y-4">
              <Link
                to="/flashcards"
                className="block w-full bg-[#9a6ebd] text-white px-6 py-3 rounded-lg hover:bg-[#8a5dad] transition-colors text-center"
              >
                Découvrir nos autres produits
              </Link>
              <Link
                to="/"
                className="block w-full bg-white text-[#9a6ebd] px-6 py-3 rounded-lg border-2 border-[#9a6ebd] hover:bg-[#9a6ebd]/5 transition-colors text-center"
              >
                Retour à l'accueil
              </Link>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default OrderConfirmationPage;